import { BrowserModule } from '@angular/platform-browser';
import { NgModule, InjectionToken } from '@angular/core';

import { AppComponent } from './app.component';
import { LeiComponent } from './lei/lei.component';
import { RouterModule } from '@angular/router';

import { appRoutes } from '../routes';
import { HomeComponent } from './home/home.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeiDetailsComponent } from './lei-details/lei-details.component'
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import { LeiService } from './backend-service/lei-service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import {LeiPackageComponent} from "./lei-package/lei-package.component";
import { LeiContactComponent } from './lei-contact/lei-contact.component';
import { SharedService } from './backend-service/shared-service';
import { DialogComponent } from './dialog/dialog.component';
import { DialogsService } from './backend-service/dialogs.service'
import {MatCheckboxModule} from "@angular/material/checkbox";

@NgModule({
  declarations: [
    AppComponent,
    LeiComponent,
    HomeComponent,
    LeiDetailsComponent,
    LeiPackageComponent,
    LeiContactComponent,
    DialogComponent
  ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        RouterModule.forRoot(appRoutes, {useHash: true, relativeLinkResolution: 'legacy'}),
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        HttpClientModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatRadioModule,
        MatDialogModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatCheckboxModule
    ],
  exports: [
    DialogComponent
  ],
  providers: [LeiService, SharedService, DialogsService],
  bootstrap: [AppComponent],
  entryComponents: [
    DialogComponent,
  ]

})
export class AppModule { }
